import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getInspectModeData } from 'src/utils/contentful';
import { ResourceCard } from 'src/components/ResourceCard';
import { ContentfulRelatedContentResource } from 'src/graphql/queries/GetSmCourse';
import { ContentType } from 'src/types';
import { ResourceType } from 'src/constants';
import { getContentProduct } from 'src/utils/getContentProduct';
import { getSlug } from 'src/utils/slug';
import { getPathUrl, getCourseUrl, getLessonUrl, withPrefix } from 'src/utils/getUrl';

export interface RecommendedResourceProps {
  resource: ContentfulRelatedContentResource;
  sequence: number;
}

export const OldRecommendedResource: React.FC<RecommendedResourceProps> = ({ resource }) => {
  const navigate = useNavigate();
  const resourceSlug = getSlug(resource);

  if (resource?.__typename === ContentType.LEARNING_PATH) {
    return (
      <ResourceCard
        contentType={ResourceType.LearningPath}
        product={getContentProduct(resource.product)}
        inspectMode={getInspectModeData(resource, ['title'])}
        title={resource.title}
        tags={[{ label: 'learning path' }]}
        link={withPrefix(getPathUrl(resourceSlug))}
        target="_self"
        onClick={() => navigate(getPathUrl(resourceSlug))}
      />
    );
  }

  if (resource?.__typename === ContentType.COURSE) {
    return (
      <ResourceCard
        contentType={ResourceType.SmCourse}
        product={getContentProduct(resource.product)}
        inspectMode={getInspectModeData(resource, ['title'])}
        title={resource.title}
        tags={[{ label: 'course' }]}
        target="_self"
        link={withPrefix(getCourseUrl(resourceSlug))}
        onClick={() => navigate(getCourseUrl(resourceSlug))}
      />
    );
  }

  if (resource?.__typename === ContentType.LESSON) {
    return (
      <ResourceCard
        contentType={ResourceType.SmLesson}
        product={getContentProduct(resource.products)}
        inspectMode={getInspectModeData(resource, ['title'])}
        title={resource.title}
        tags={[{ label: 'lesson' }]}
        target="_self"
        link={withPrefix(getLessonUrl({ lessonSlug: resourceSlug }))}
        onClick={() => navigate(getLessonUrl({ lessonSlug: resourceSlug }))}
      />
    );
  }

  return null;
};
